import React, { useState, useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

function ControlledGif({ gifSrc, staticSrc, delay = 0, className = '', alt = 'gif', preload = false }) {
  const [imgSrc, setImgSrc] = useState(staticSrc || gifSrc);
  const [isGifLoaded, setIsGifLoaded] = useState(false);
  const timeoutRef = useRef(null);
  const gifPreloadRef = useRef(null);

  const { ref: imgInviewRef, inView: imgInView } = useInView({
    threshold: 0.1,
  });

  // Precarica la GIF in background se richiesto
  useEffect(() => {
    if (preload && !isGifLoaded) {
      const img = new Image();
      img.src = gifSrc;
      img.onload = () => {
        setIsGifLoaded(true);
        gifPreloadRef.current = gifSrc;
      };
    }
  }, [preload, gifSrc, isGifLoaded]);

  useEffect(() => {
    // Cancella sempre il timeout esistente prima di impostarne uno nuovo
    clearTimeout(timeoutRef.current);

    if (imgInView) {
      timeoutRef.current = setTimeout(() => {
        // Usa la GIF precaricata o carica normalmente (senza timestamp per cache)
        setImgSrc(gifSrc);
      }, delay);
    } else {
      setImgSrc(staticSrc || gifSrc);
    }

    return () => {
      // Pulizia del timeout quando il componente si smonta o la dipendenza cambia
      clearTimeout(timeoutRef.current);
    };
  }, [imgInView, gifSrc, staticSrc, delay]);

  return (
    <img ref={imgInviewRef} src={imgSrc} alt={alt} className={className} loading="lazy" />
  );
}

export default ControlledGif;
